export default ({ request }) => ({
  ecomAmzPeriodListApi(data = {}) {
    return request({
      url: '/ecom/amz/period/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzPeriodDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/period/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzPeriodSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/period/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzPeriodVerificationApi(data = {}) {
    return request({
      url: '/ecom/amz/period/verification',
      method: 'POST',
      data,
    })
  },
  ecomAmzPeriodChangeApi(data = {}) {
    return request({
      url: '/ecom/amz/period/change',
      method: 'POST',
      data,
    })
  },
  ecomAmzPeriodDelApi(data = {}) {
    return request({
      url: '/ecom/amz/period/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzPeriodIsEnableApi(data = {}) {
    return request({
      url: '/ecom/amz/period/isEnable',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
})
